var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurveBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "auto",
    style: {
      display: "block"
    },
    viewBox: "0 0 1443 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6201204,39.891919 C181.719664,39.891919 228.106946,123.893021 512.585588,123.893021 C797.06423,123.893021 1277.52816,-58.6093734 1442.01581,19.3916501 L1442.01581,159.893087 L0,159.893087 C0,84.166514 0,46.3032276 0,46.3032276 C1.9606095e-29,46.3032276 22.3178019,39.891919 52.6201204,39.891919 Z",
    id: "section-curve-top",
    fill: "#37B5ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveBg);
export default __webpack_public_path__ + "static/media/curve_bg.20a375530c1ca2f5df2662e5ee0b4256.svg";
export { ForwardRef as ReactComponent };